import { idmApi } from './http';

export async function getAllOrgs() {
  const response = await idmApi.get('/orgs');
  return response.data.data;
}

export async function createNewOrg(org) {
  const response = await idmApi.post('/orgs', { ...org });
  return response.data;
}

export async function updateOrg(id, org) {
  const response = await idmApi.put(`/orgs/${id}`, { ...org });
  return response.data;
}

export async function getOrgProducts(id) {
  const response = await idmApi.get(`/orgs/${id}/products`);
  return response.data;
}

export async function getOrgUsers() {
  const response = await idmApi.get('/user-orgs');
  return response.data;
}
